import { Helmet } from 'react-helmet-async';

import { useState, useEffect } from 'react';
// @mui
import { Card, Stack, Button, Container, Typography, TextField, DialogTitle, DialogContent, DialogActions, Table, Dialog, TableContainer, TableBody, TableRow, TableCell, Input, Select, MenuItem, InputLabel, Switch } from '@mui/material';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { useNavigate } from 'react-router-dom';
import { FaEdit, FaTrash, FaInfoCircle, FaCopy, FaBook } from 'react-icons/fa';
import Iconify from '../components/iconify';
import { SerachUser, deleteUsers, getQuizeSummaryReport, updateUserProfileName, toggleUserStatus, getAssigncourses, getAllCourseDetails, getAllSubjectDetails, Assignbook, setScreenCast, deleteCourseUser } from '../Servies/AdmiServices';
import TableData from '../components/common/TableData';
import Loader from '../components/common/Loader';

export default function UserPage() {
  const navigate = useNavigate();
  const [phoneNumber, setphoneNumber] = useState('');
  const [Name, setName] = useState('');
  const [userName, setUserName] = useState('');
  const [uacCode, setUacCode] = useState('');
  const [userdata, setUserData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [removeUser, setRemoveUser] = useState();
  const headers = ['Name', 'UserName', 'Profile User Name', 'Email ID', 'School Name', 'Status', 'Quizz Prize', 'Action'];
  const [showLoader, setShowLoader] = useState(false);
  const [prizeOpen, setPrizeOpen] = useState(false);
  const [profileNameOpen, setProfileNameOpen] = useState(false);
   const [profileName, setProfileName] = useState('');
  const [quizData, setQuizData] = useState(null);
  const [copied, setCopied] = useState(false);
  const [courseData, setCourseData] = useState([]);
  const [allCourses, setAllCourses] = useState([]);
  const [subjectsByCourseId, setSubjectsByCourseId] = useState({});
  const [addRowByUser, setAddRowByUser] = useState({});

  const [IsUserDataVisible, setIsUserDataVisible] = useState(false);

  useEffect(() => {
    getAllCourseDetails().then((res) => {
      const courseList = res?.data?.map((data) => ({
        courseName: data?.courseDisplayName,
        courseId: data?.courseId,
      })) || [];
      setAllCourses(courseList);
    });
  }, []);

  // const handleMobileNumberChange = (e) => {
  //   setphoneNumber(e.target.value);
  // };

  const handleMobileNumberChange = (e) => {
    // Use regex to remove non-numeric characters from the input
    const numericValue = e.target.value.replace(/\D/g, '');
    // Limit the input to a maximum of 10 characters
    const truncatedValue = numericValue.slice(0, 10);
    setphoneNumber(truncatedValue);
  };

  const handlenameChange = (e) => {
    setName(e.target.value);
  };

   const handleUserNameChange = (e) => {
    setUserName(e.target.value);
  };

  const handleUacCodeChange = (e) => {
    setUacCode(e.target.value);
  };

 
  const handleNewUserClick = () => {
    navigate('/dashboard/manageuser');
  };
  const handleEditUser = (userId) => {
    navigate(`/dashboard/manageuser?userId=${userId}`);
  };

  const [isCardVisible, setIsCardVisible] = useState(false);
  
 
  const copyToClipboard = async (uName) => {
    console.log("name", uName)
    try {
      await navigator.clipboard.writeText(uName);
    } catch (err) {
      console.error('Failed to copy!', err);
    }
  };
  const handleSubmit = (event) => {
    event.preventDefault(); // Prevent form submission
    setIsLoading(true); // Set loading state to true

    if (!Name && !phoneNumber && !userName && !uacCode) {
      // All search fields are empty; you can handle this case as needed
      console.log('Please enter a name, mobile number, username, or UAC code.');
      setIsLoading(false);
      return;
    }

    SerachUser(Name, phoneNumber, userName, uacCode)
      .then((res) => {
        if (res?.data?.SUCCESS === true) {
          const fetchedUsers = (res?.data?.Data || []).filter((item) => item !== null);
          setUserData(res?.data?.Data);
          setIsCardVisible(true);
          fetchCourseData(fetchedUsers);
        } else {
          // console.log('No matching users found.');
          setIsCardVisible(false);
          setCourseData([]);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        // console.log('Error:', error);
        setIsLoading(false);
        setIsCardVisible(false);
        setCourseData([]);
      });
  };

  const fetchCourseData = (fetchedUsers) => {
    Promise.all(
      fetchedUsers.map((user) =>
        getAssigncourses(user.userId)
          .then((response) => ({
            userId: user.userId,
            userName: user.userName,
            courses: response?.data?.SUCCESS ? response.data.Data || [] : [],
          }))
          .catch(() => ({ userId: user.userId, userName: user.userName, courses: [] }))
      )
    ).then((results) => {
      setCourseData(results);
    });
  };

  const refreshUserCourses = (userId, userDisplayName) => {
    getAssigncourses(userId).then((response) => {
      const courses = response?.data?.SUCCESS ? response.data.Data || [] : [];
      setCourseData((prevData) =>
        prevData.map((userCourses) =>
          userCourses.userId === userId ? { ...userCourses, userName: userDisplayName, courses } : userCourses
        )
      );
    });
  };

  const handleToggleAddRow = (userId) => {
    setAddRowByUser((prev) => {
      const isOpen = prev[userId]?.show;
      return {
        ...prev,
        [userId]: isOpen ? { show: false } : { show: true, courseName: '', subjectName: '', uacCode: '' },
      };
    });
  };

  const handleNewCourseCourseChange = (userId, courseName) => {
    setAddRowByUser((prev) => ({
      ...prev,
      [userId]: { ...prev[userId], courseName, subjectName: '' },
    }));
    const selectedCourseObject = allCourses.find((course) => course.courseName === courseName);
    if (selectedCourseObject && !subjectsByCourseId[selectedCourseObject.courseId]) {
      getAllSubjectDetails(selectedCourseObject.courseId).then((subjectDetails) => {
        const subjectList = subjectDetails?.data?.map((data) => ({
          subjectName: data?.levelDisplayName,
          levelId: data?.levelId,
        })) || [];
        setSubjectsByCourseId((prev) => ({ ...prev, [selectedCourseObject.courseId]: subjectList }));
      });
    }
  };

  const handleNewCourseSubjectChange = (userId, subjectName) => {
    setAddRowByUser((prev) => ({
      ...prev,
      [userId]: { ...prev[userId], subjectName },
    }));
  };

  const handleNewCourseUacChange = (userId, uacCode) => {
    setAddRowByUser((prev) => ({
      ...prev,
      [userId]: { ...prev[userId], uacCode },
    }));
  };

  const handleSaveNewCourse = (userId, userDisplayName) => {
    const entry = addRowByUser[userId];
    const selectedCourseObject = allCourses.find((course) => course.courseName === entry?.courseName);
    if (!selectedCourseObject) {
      toast.error('Please select a course', { position: toast.POSITION.TOP_RIGHT });
      return;
    }
    const subjectList = subjectsByCourseId[selectedCourseObject.courseId] || [];
    const selectedSubjectObject = subjectList.find((subjectItem) => subjectItem.subjectName === entry?.subjectName);
    if (!selectedSubjectObject) {
      toast.error('Please select a subject', { position: toast.POSITION.TOP_RIGHT });
      return;
    }

    setIsLoading(true);
    Assignbook([
      {
        courseId: selectedCourseObject.courseId,
        subjectId: selectedSubjectObject.levelId.toString(),
        userId,
        uaCode: entry.uacCode,
        latlong: '',
      },
    ])
      .then((response) => {
        toast.success(response?.data || 'Course assigned', { position: toast.POSITION.TOP_RIGHT });
        setAddRowByUser((prev) => ({ ...prev, [userId]: { show: false } }));
        refreshUserCourses(userId, userDisplayName);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error('Error assigning course:', error);
        toast.error('Error assigning course', { position: toast.POSITION.TOP_RIGHT });
        setIsLoading(false);
      });
  };

  const handleAllowCast = (userId, userDisplayName, item) => {
    setIsLoading(true);
    setScreenCast(userId, item.courseId, item.subjectId)
      .then((response) => {
        if (response?.data?.status === 'SUCCESS') {
          toast.success(response.data.message, { position: toast.POSITION.TOP_RIGHT });
          setCourseData((prevData) =>
            prevData.map((userCourses) =>
              userCourses.userId === userId
                ? {
                    ...userCourses,
                    courses: userCourses.courses.map((course) =>
                      course.id === item.id ? { ...course, castingEnabled: !course.castingEnabled } : course
                    ),
                  }
                : userCourses
            )
          );
        } else {
          toast.error('Error while enabling casting...', { position: toast.POSITION.TOP_RIGHT });
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.error('Error enabling casting:', error);
        toast.error('Error while enabling casting...', { position: toast.POSITION.TOP_RIGHT });
        setIsLoading(false);
      });
  };

  const handleDeleteCourse = (userId, userDisplayName, id) => {
    setIsLoading(true);
    deleteCourseUser(id)
      .then((res) => {
        if (res?.data.SUCCESS === true) {
          toast.success(res?.data?.Data, { position: toast.POSITION.TOP_RIGHT });
          refreshUserCourses(userId, userDisplayName);
        } else {
          toast.error('Error while removing course', { position: toast.POSITION.TOP_RIGHT });
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.error('Error deleting course:', error);
        toast.error('Error while removing course', { position: toast.POSITION.TOP_RIGHT });
        setIsLoading(false);
      });
  };

  const handleDeleteUser = (userId) => {
    setIsLoading(true);
    deleteUsers(userId)
      .then((response) => {
        if (response?.data.SUCCESS === true) {
          // setRemoveUser(response?.data);

          toast.success(response?.data?.Data, {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.error(response?.data?.data, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching user data:', error);
        setIsLoading(false);
      });
  };

  const handleViewQuizeSummary = (userId) => {
    setIsLoading(true);
    getQuizeSummaryReport(userId)
      .then((response) => {
        if (response?.status === 200) {
          setQuizData(response.data)
          setPrizeOpen(true)
          console.log(quizData)
        } else {
          toast.error("Error Occured...", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
        setIsLoading(false);
      });
  };

  const handleUserProfileNameChange = (e) => {
    e.preventDefault()
    setIsLoading(true)
    updateUserProfileName(profileName.userId, profileName.profileUserName).then((response) => {
      if (response.status === 200) {
        toast.success("Profile User Name Changed", { position: toast.POSITION.TOP_RIGHT, });
        setIsLoading(false)
        setProfileNameOpen(false)
        setIsCardVisible(false)
        setUserData([])
      } else {
        toast.error("Error Occured", { position: toast.POSITION.TOP_RIGHT, });
        setIsLoading(false)
      }
    });
  }


  const handleToggleUserStatus = (userId, isActive) => {
    const newStatus = isActive ? 'disable' : 'enable';
    setIsLoading(true);
    toggleUserStatus(userId, newStatus)
      .then((response) => {
        if (response?.data?.success === true) {
          toast.success(response?.data?.message, {
            position: toast.POSITION.TOP_RIGHT,
          });
          setUserData((prevData) =>
            prevData.map((user) =>
              user?.userId === userId
                ? { ...user, isActive: !isActive }
                : user
            )
          );
        } else {
          toast.error(response?.data?.message || 'Failed to update user status', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.error('Error toggling user status:', error);
        toast.error('Error updating user status', {
          position: toast.POSITION.TOP_RIGHT,
        });
        setIsLoading(false);
      });
  };

  const handleClose = () => {
    setPrizeOpen(false);
  };


  const users = userdata
    .filter((item) => item !== null)
    .map((item) => {
      return {
        Name: item?.name,
        UserName: item?.userName,
        "Profile User Name": (<>
          <span>{item?.profileUserName}  </span>
          <FaEdit
            style={{ cursor: 'pointer', marginRight: '10px' }}
            onClick={() => { setProfileName(item); setProfileNameOpen(true) }}
          /> 
          <FaCopy
        style={{ cursor: 'pointer' }}
        onClick={()=>{ setProfileName(item);copyToClipboard(item?.profileUserName)}}
        title="Copy username"
      />
      
   
     
      {copied && <span style={{ marginLeft: 8, color: 'green' }}>Copied!</span>}
 
        </>
        ),
        'Email ID': item.email,
        'School Name': item.schoolName || '-',
        Status: item.isActive ? (
          <Button variant="contained" color="primary" onClick={() => handleToggleUserStatus(item.userId, true)}>
            Active
          </Button>
        ) : (
          <Button variant="contained" color="error" onClick={() => handleToggleUserStatus(item.userId, false)}>
            Inactive
          </Button>
        ),
        Action: (
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <FaEdit
              style={{ cursor: 'pointer' }}
              onClick={() => handleEditUser(item.userId)}
            />
            <FaTrash
              style={{ cursor: 'pointer' }}
              onClick={() => handleDeleteUser(item.userId)}
            />
          </div>
        ),
        'Quizz Prize': (
          <Button variant="contained" color="primary"
            onClick={() => { handleViewQuizeSummary(item.userId) }}
          >View Prize</Button>
        )
      };
    });

  return (
    <>
      {isLoading && <Loader />}
      <ToastContainer />
      <Helmet>
        <title> User </title>
      </Helmet>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            User
          </Typography>
          <Button
            variant="contained"
            startIcon={<Iconify icon="eva:plus-fill" />}
            // onClick={
            //   Navigate('/dashboard/app/manageuser')
            //   }>
            onClick={handleNewUserClick}
          >
            New User
          </Button>
        </Stack>

        <form onSubmit={handleSubmit}>
          <TextField
            name="Name"
            label="Name"
            style={{ width: '260px', marginRight: '10px' }}
            onChange={handlenameChange}
          />
          <TextField
            name="phoneNumber"
            label="Mobile No"
            style={{ width: '260px', marginRight: '10px' }}
            onChange={handleMobileNumberChange}
            value={phoneNumber} // Set the value of the TextField to the phoneNumber state
          />
          <TextField
            name="userName"
            label="Profile UserName"
            style={{ width: '260px', marginRight: '10px' }}
            onChange={handleUserNameChange}
            value={userName} // Set the value of the TextField to the userName state
          />
          <TextField
            name="uacCode"
            label="UAC Code"
            style={{ width: '260px', marginRight: '10px' }}
            onChange={handleUacCodeChange}
            value={uacCode}
          />
          <button type="submit" style={{ width: '120px', height: '40px' }}>
            Search
          </button>
        </form>
        <br />

        {isCardVisible && (
          <>
            <Card>
              {users.length > 0 ? (
                <TableData data={users} headers={headers} rowsPerPageOptions={[5, 10, 20]} />
              ) : (
                'No Data Found'
              )}
            </Card>

            <Typography variant="h6" sx={{ mt: 4, mb: 2 }}>
              Course &amp; Subject Access
            </Typography>
            {courseData.map((userCourses) => {
              const addRow = addRowByUser[userCourses.userId] || {};
              const subjectOptions = (() => {
                const selectedCourseObject = allCourses.find((course) => course.courseName === addRow.courseName);
                return selectedCourseObject ? subjectsByCourseId[selectedCourseObject.courseId] || [] : [];
              })();

              return (
                <Card key={userCourses.userId} sx={{ mb: 2 }}>
                  <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ p: 2, pb: 0 }}>
                    <Typography variant="subtitle2">{userCourses.userName}</Typography>
                    <Button
                      variant="contained"
                      size="small"
                      onClick={() => handleToggleAddRow(userCourses.userId)}
                    >
                      Add Course
                    </Button>
                  </Stack>

                  {addRow.show && (
                    <Stack direction="row" spacing={2} alignItems="center" sx={{ p: 2 }}>
                      <div>
                        <InputLabel>Course</InputLabel>
                        <Select
                          variant="standard"
                          sx={{ minWidth: 160 }}
                          value={addRow.courseName || ''}
                          onChange={(e) => handleNewCourseCourseChange(userCourses.userId, e.target.value)}
                        >
                          {allCourses.map((course) => (
                            <MenuItem key={course.courseId} value={course.courseName}>
                              {course.courseName}
                            </MenuItem>
                          ))}
                        </Select>
                      </div>
                      <div>
                        <InputLabel>Subject</InputLabel>
                        <Select
                          variant="standard"
                          sx={{ minWidth: 160 }}
                          value={addRow.subjectName || ''}
                          onChange={(e) => handleNewCourseSubjectChange(userCourses.userId, e.target.value)}
                        >
                          {subjectOptions.map((subjectItem) => (
                            <MenuItem key={subjectItem.levelId} value={subjectItem.subjectName}>
                              {subjectItem.subjectName}
                            </MenuItem>
                          ))}
                        </Select>
                      </div>
                      <TextField
                        variant="standard"
                        label="UAC Code"
                        value={addRow.uacCode || ''}
                        onChange={(e) => handleNewCourseUacChange(userCourses.userId, e.target.value)}
                      />
                      <Button
                        variant="contained"
                        size="small"
                        onClick={() => handleSaveNewCourse(userCourses.userId, userCourses.userName)}
                      >
                        Save
                      </Button>
                    </Stack>
                  )}

                  {userCourses.courses.length === 0 ? (
                    <Typography variant="body2" color="text.secondary" sx={{ p: 2 }}>No course found.</Typography>
                  ) : (
                    <TableContainer>
                      <Table size="small">
                        <TableBody>
                          <TableRow sx={{ bgcolor: 'grey.100' }}>
                            <TableCell><strong>#</strong></TableCell>
                            <TableCell><strong>Course Name</strong></TableCell>
                            <TableCell><strong>Subject Name</strong></TableCell>
                            <TableCell><strong>Start Date</strong></TableCell>
                            <TableCell><strong>End Date</strong></TableCell>
                            <TableCell><strong>UAC Code</strong></TableCell>
                            <TableCell><strong>Allow Cast</strong></TableCell>
                            <TableCell><strong>Action</strong></TableCell>
                          </TableRow>
                          {userCourses.courses.map((row, idx) => (
                            <TableRow key={idx} hover>
                              <TableCell>{idx + 1}</TableCell>
                              <TableCell>{row.courseName}</TableCell>
                              <TableCell>{row.subjectName}</TableCell>
                              <TableCell>{row.startDate || '—'}</TableCell>
                              <TableCell>{row.endDate || '—'}</TableCell>
                              <TableCell>{row.uacCode || '—'}</TableCell>
                              <TableCell>
                                <Switch
                                  checked={row.castingEnabled === true}
                                  color="primary"
                                  disabled={row.castingEnabled === true}
                                  onChange={() => handleAllowCast(userCourses.userId, userCourses.userName, row)}
                                />
                              </TableCell>
                              <TableCell>
                                <FaTrash
                                  style={{ cursor: 'pointer' }}
                                  onClick={() => handleDeleteCourse(userCourses.userId, userCourses.userName, row.id)}
                                />
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  )}
                </Card>
              );
            })}
          </>
        )}
        <Dialog maxWidth={'md'} fullWidth open={prizeOpen} onClose={handleClose}>
          <DialogTitle>User Quizz Information</DialogTitle>
          <DialogContent>
            <TableContainer>
              <Table>
                <TableBody>
                  <TableRow>
                    <TableCell><Typography variant="body1">Username</Typography></TableCell>
                    <TableCell><Typography variant="body1">{quizData?.data?.userName}</Typography></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell><Typography variant="body1">Number of Quizzes</Typography></TableCell>
                    <TableCell><Typography variant="body1">{quizData?.data?.numberOfQuizzes}</Typography></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell><Typography variant="body1">Total Points</Typography></TableCell>
                    <TableCell><Typography variant="body1">{quizData?.data?.totalPoints}</Typography></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell><Typography variant="body1">Total Score</Typography></TableCell>
                    <TableCell><Typography variant="body1">{quizData?.data?.totalScore}</Typography></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell><Typography variant="body1">Total Payout</Typography></TableCell>
                    <TableCell><Typography variant="body1">{quizData?.data?.totalPayout}</Typography></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell><Typography variant="body1">Best Rank</Typography></TableCell>
                    <TableCell><Typography variant="body1">{quizData?.data?.bestRank}</Typography></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell><Typography variant="body1">Active Eduteck User</Typography></TableCell>
                    <TableCell><Typography variant="body1">{quizData?.data?.isAnActiveEduteckUser.toString()}</Typography></TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog maxWidth={'md'} open={profileNameOpen} onClose={() => { setProfileNameOpen(false) }}>
          <DialogTitle>Update Profile User Name</DialogTitle>
          <DialogContent >
            <form style={{ padding: '10px' }} onSubmit={handleUserProfileNameChange}>
              <TextField name="ProfileUserName" label="Profile User Name"
                value={profileName.profileUserName} onChange={(e) => { setProfileName({ ...profileName, profileUserName: e.target.value }) }}
                style={{ width: '260px', marginRight: '10px' }}
              />
              <button type="submit" style={{ width: '120px', height: '40px' }}>
                Update
              </button>
            </form>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => { setProfileNameOpen(false) }} color="primary">
              Close
            </Button>
              
          </DialogActions>
        </Dialog>
      </Container>
    </>
  );
}
